import {
  HomeOutlined,
  MenuOutlined,
  UserAddOutlined,
  GlobalOutlined,
  SafetyCertificateOutlined,
  CarOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation, Navigate, Outlet } from "react-router-dom";
import { Layout, Menu, Modal } from "antd";
import { useState, useEffect } from "react";
import Typography from "./Typography";
import { COLORS } from "../constants/Colors";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import { ASSET_BASE_PATH } from "../constants/Config";
import ProfileMenu from "./UserProfileMenu";
import MyButton from "./Button";
import ParcelIcon from "./Icon/Parcel";
import MarkerIcon from "./Icon/Marker";
import ChangePasswordModal from "../containers/changePassword/ChangePasswordCard";
import authenService from "../utils/services/authenService";
import { langActionn } from "../utils/redux/actions/langAction";
import AppConfig from "../config";
import { useDispatch, useSelector } from "react-redux";
import GetProfile from "./VariableStore";
import { instance } from "./AxiosClient";
import OrderModal from "./OrderModal";
import ShipmentDetailModal from "./ShipmentDetailModal";
import ShipmentPreviewModal from "./ShipmentPreviewModal";
import _ from "lodash";
import { persistor, store } from "../utils/redux/store";
import customerService from "../utils/services/customerService";
import { customer_profile } from "../utils/redux/actions/customerProfileAction";
import jwt_decode from "jwt-decode";
import { login } from "../utils/redux/actions/authenAction";
import UserProfileModal from "./UserProfileModal";
import { ROUTES } from "../constants/Routes";
import { errorNotification, successNotification } from "./Notification";
import { FormattedMessage, useIntl } from "react-intl";
import loginService from "../utils/services/LoginService";
import { getGeoCompanyApi } from "../controllers/mapkey";
import { mapKeyAction } from "../utils/redux/actions/mapKeyAction";
// import garage from "../assets/garage.svg";
import { ReactComponent as GarageIcon } from "../assets/garage.svg";
import moreTime from "../assets/more_time.svg";
import PrivacyPolicyModal from "../containers/PrivacyPolicyModal";
import CookiePolicyModal from "../containers/CookiePolicyModal";

const { Header, Content, Footer, Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}
//<CarOutlined style={{color: COLORS.Primary}}
const widthIcon = "16px";

const items = [
  getItem(
    <FormattedMessage id="menuHome" defaultMessage="Home" />,
    "1",
    <HomeOutlined style={{ color: COLORS.Primary, width: widthIcon }} />
  ),
  getItem(
    <FormattedMessage id="menuChecking" defaultMessage="ตรวจสอบสถานะช่องจอด" />,
    "2",
    <GarageIcon style={{ width: widthIcon }} />
  ),
  getItem(
    <FormattedMessage id="menuQueue" defaultMessage="คิวนำส่งสินค้า" />,
    "3",
    <ClockCircleOutlined style={{ color: COLORS.Primary, width: widthIcon }} />
  ),
  // getItem(<FormattedMessage id='menuShipment' defaultMessage='Create Shipment' />, '2', <ParcelIcon />),
  // getItem(<FormattedMessage id='menuTrackingShipment' defaultMessage='Tracking My Shipment' />, '3', <MarkerIcon  color={COLORS.Primary}/>),
  // getItem(
  //   <FormattedMessage id="menuCustomer" defaultMessage="My Customer" />,
  //   "4",
  //   <UserAddOutlined style={{ color: COLORS.Primary, width: widthIcon }} />
  // ),
  getItem(
    <FormattedMessage
      id="menuChangePasssword"
      defaultMessage="Change Password"
    />,
    "5",
    <SafetyCertificateOutlined
      style={{ color: COLORS.Primary, width: widthIcon }}
    />
  ),
  getItem(
    <FormattedMessage id="menuLanguage" defaultMessage="Language" />,
    "6",
    <GlobalOutlined style={{ color: COLORS.Primary }} />,
    [
      getItem(
        <span
          style={
            !localStorage.getItem("lang") ||
            localStorage.getItem("lang") === "EN"
              ? null
              : { color: "#909AAF" }
          }
        >
          <FormattedMessage id="englishLanguage" defaultMessage="English" />
        </span>,
        "6.1"
      ),
      getItem(
        <span
          style={
            localStorage.getItem("lang") === "TH" ? null : { color: "#909AAF" }
          }
        >
          <FormattedMessage id="thaiLanguage" defaultMessage="Thai" />
        </span>,
        "6.2"
      ),
      // getItem(
      //   <span
      //     style={
      //       localStorage.getItem("lang") === "BM" ? null : { color: "#909AAF" }
      //     }
      //   >
      //     <FormattedMessage id="burmeseLanguage" defaultMessage="Burmese" />
      //   </span>,
      //   "6.3"
      // ),
    ],
    "group"
  ),
];

const MyHeader = (props) => {
  const { onToggleMenu } = props;
  const isDesktop = useIsDesktop();

  return (
    <Header
      className="px-4"
      style={{
        background: COLORS.White,
        zIndex: 10,
        height: 64,
        maxHeight: 64,
      }}
    >
      <div className="d-flex flex-row justify-content-between align-items-center h-100">
        {isDesktop ? (
          <></>
        ) : (
          <img
            height="44px"
            src={`${ASSET_BASE_PATH}/assets/Logo_TC.png`}
            alt="logo"
          />
        )}
        {!isDesktop && (
          <MenuOutlined
            style={{
              color: COLORS.Primary,
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={onToggleMenu}
          />
        )}
      </div>
    </Header>
  );
};

const MyFooter = () => {
  const isDesktop = useIsDesktop();
  return (
    <Footer
      className={`d-flex align-items-center ${
        isDesktop ? "justify-content-start" : "justify-content-center"
      } px-4`}
      style={{
        height: 46,
        backgroundColor: COLORS.Primary,
      }}
    >
      <Typography size="12.5px" color={COLORS.White}>
        Powered by © RAPIDTECH Co., Ltd.(V{" "}
        {process.env.REACT_APP_COMPANY_VERSION_FOOTER})
      </Typography>
    </Footer>
  );
};

const MySider = (props) => {
  const {
    onClickMenuIcon,
    onViewProfile,
    selectedMenuKey,
    onChangeMenu,
    profileData,
    selectLang,
    handleClickCreateOrder,
    focusShipmentDetail,
    shipmentBodyCancel,
    setIsOpenConfirmModal,
    setIsOpenShipmentModal,
    isOpenConfirmModal,
    ...rest
  } = props;
  const { collapsed } = props;
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [isOpenPasswordModal, setIsOpenPasswordModal] = useState(false);
  const intl = useIntl();
  const [isOpenConfirmSignOutModal, setIsOpenConfirmSignOutModal] =
    useState(false);
  const Lang = localStorage.getItem("lang");
  //----------------------------------------------
  const [isOpenPolicyMenu, setIsOpenPolicyMenu] = useState(false);
  const [isOpenPrivacyPolicy, setIsOpenPrivacyPolicy] = useState(false);
  const [isOpenCookiePolicy, setIsOpenCookiePolicy] = useState(false);
  const [acceptPolicy, setAcceptPolicy] = useState(false);

  const navigation = [
    { label: "Home", key: "1", target: "/home" },
    // { label: 'Order', key: '2' },
    { label: "Checking", key: "2", target: "/checkingstatus" },
    { label: "Queue", key: "3", target: "/queue" },
    // { label: 'Tracking', key: '3', target: '/tracking' },
    { label: "Customer", key: "4", target: "/customer" },
  ];

  const handleMenuClick = ({ key }) => {
    const { target } = navigation.find((item) => item.key === key) || {};
    // console.log('MMMMMEEENU',target);
    onChangeMenu(key);
    if (target) {
      navigate(target);
      if (!isDesktop) onClickMenuIcon();
      // } else if (key === '2') {
      // //console.log('CODer');
      // handleClickCreateOrder();
    } else if (key === "5") {
      // //console.log('cahnge password');
      setIsOpenPasswordModal(true);
    } else if (key === "6.1") {
      selectLang("EN");
    } else if (key === "6.2") {
      selectLang("TH");
    } else if (key === "6.3") {
      selectLang("BM");
    }
  };

  const ModalConfirmSignOut = () => {
    return (
      <>
        {isDesktop ? (
          <Modal
            open={isOpenConfirmSignOutModal}
            onOk={signout}
            onCancel={handleCloseConfirmSignOut}
            width={310}
            className="custom-modal"
            centered={isDesktop ? true : false}
            footer={[
              <div>
                <MyButton
                  onClick={handleCloseConfirmSignOut}
                  style={{
                    width: isDesktop ? "30%" : "30%",
                    marginLeft: "0px",
                    marginTop: "0px",
                    marginRight: "5px",
                  }}
                >
                  <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
                </MyButton>{" "}
                <MyButton
                  isPrimary
                  onClick={signout}
                  style={{
                    width: isDesktop ? "30%" : "30%",
                    marginInlineStart: "0px",
                  }}
                >
                  <FormattedMessage id="btnOK" defaultMessage="Ok" />
                </MyButton>
              </div>,
            ]}
          >
            <div>
              <Typography
                isBold
                size="16px"
                color={COLORS.Primary}
                className="text-center p-2"
              >
                <FormattedMessage
                  id="confirmsignout"
                  defaultMessage="Confirm Sign Out"
                />
              </Typography>
              <Typography size="13px" className="text-center p-3">
                <FormattedMessage
                  id="contentsignout"
                  defaultMessage="Are you sure you want to Sign Out ?"
                />
              </Typography>
            </div>
          </Modal>
        ) : (
          <Modal
            open={isOpenConfirmSignOutModal}
            onOk={signout}
            onCancel={handleCloseConfirmSignOut}
            className="custom-modal"
            bodyStyle={{ overflow: "hidden" }}
            width={310}
            centered
            style={{
              marginTop: "65%",
            }}
            footer={[
              <div>
                <MyButton
                  onClick={handleCloseConfirmSignOut}
                  style={{
                    width: isDesktop ? "30%" : "30%",
                    marginLeft: "0px",
                    marginTop: "0px",
                    marginRight: "5px",
                  }}
                >
                  <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
                </MyButton>{" "}
                <MyButton
                  isPrimary
                  onClick={signout}
                  style={{
                    width: isDesktop ? "30%" : "30%",
                    marginInlineStart: "0px",
                  }}
                >
                  <FormattedMessage id="btnOK" defaultMessage="Ok" />
                </MyButton>
              </div>,
            ]}
          >
            <div>
              <Typography
                isBold
                size="16px"
                color={COLORS.Primary}
                className="text-center p-2"
              >
                <FormattedMessage
                  id="confirmsignout"
                  defaultMessage="Confirm Sign Out"
                />
              </Typography>
              <Typography size="13px" className="text-center p-3">
                <FormattedMessage
                  id="contentsignout"
                  defaultMessage="Are you sure you want to Sign Out ?"
                />
              </Typography>
            </div>
          </Modal>
        )}
      </>
    );
  };

  const signout = async () => {
    const _authenService = new authenService();
    const body = {
      client_id: `${AppConfig.CLIENT_ID}`,
      client_secret: `${AppConfig.CLIENT_SECRET}`,
      refresh_token: state.authenReducer.refreshToken,
    };
    await _authenService
      .logout(body)
      .then((response) => {
        persistor.purge();
        window.location.reload();
      })
      .catch((err) => {
        persistor.purge();
        window.location.reload();
      });
  };

  const handleOpenConfirmSignOut = () => {
    setIsOpenConfirmSignOutModal(true);
  };

  const handleCloseConfirmSignOut = () => {
    setIsOpenConfirmSignOutModal(false);
  };

  const handleClickCancelShipment = async () => {
    const comCode = GetProfile("customerCode");
    const id = _.get(focusShipmentDetail, "orderId");
    try {
      await instance.put(
        `/v5/order/manager/company/${comCode}/web/deliveryorder/loopmerchant/${id}`,
        shipmentBodyCancel
      );
      setIsOpenConfirmModal(false);
      setIsOpenShipmentModal(false);
      successNotification(
        intl.formatMessage({
          id: "saveSuccessNotification",
          defaultMessage: "Success",
        })
      );
    } catch (error) {
      errorNotification(
        intl.formatMessage({
          id: "saveErrorNotification",
          defaultMessage: "Failed",
        })
      );
    }
  };

  const onOpenCookiePolicy = () => {
    handleOpenCookiePolicy();
    setIsOpenPolicyMenu(false);
  };

  const onOpenPrivacyPolicy = () => {
    handleOpenPrivacyPolicy();
    setIsOpenPolicyMenu(false);
  };

  const handleOpenCookiePolicy = () => {
    //console.log('open Modal');
    setIsOpenCookiePolicy(true);
  };

  const handleOpenPrivacyPolicy = () => {
    setIsOpenPrivacyPolicy(true);
  };

  const handleClickAcceptPolicy = () => {
    setAcceptPolicy(!acceptPolicy);
    //console.log('acceptPolicy: ', acceptPolicy);
  };

  return (
    <Sider
      {...rest}
      style={{
        background: "white",
      }}
      width={isDesktop ? 280 : "100%"}
    >
      <div className="d-flex flex-column h-100 justify-content-between">
        <div>
          <div
            style={{
              display: "flex",
              height: 64,
              maxHeight: 64,
              padding: collapsed ? "0px" : "0px 16px 0px 24px",
              background: "white",
              justifyContent: collapsed ? "center" : "space-between",
              alignItems: "center",
            }}
          >
            {!collapsed && (
              <img
                height="44px"
                src={`${ASSET_BASE_PATH}/assets/Logo_TC.png`}
                alt="logo"
              />
            )}
            <div onClick={onClickMenuIcon}>
              <MenuOutlined
                style={{
                  color: COLORS.Primary,
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
          {!collapsed && (
            <ProfileMenu
              onViewProfile={onViewProfile}
              profileData={profileData}
            />
          )}
          <div style={{ height: "calc(100vh -290px)", overflowY: "auto" }}>
            <Menu
              className="ffr"
              theme="light"
              selectedKeys={selectedMenuKey}
              mode="inline"
              items={items}
              style={{
                justifyContent: "start",
                alignItems: "baseline",
                textAlign: "left",
              }}
              onClick={handleMenuClick}
              defaultOpenKeys={["6"]}
            />
          </div>
        </div>
        {/* {!collapsed && (

        )} */}
        {!collapsed && (
          <div className="w-100 px-4 py-3">
            <div
              style={{ justifyContent: "center" }}
              className="d-flex flex-row py-4"
            >
              <div onClick={onOpenPrivacyPolicy}>
                <Typography
                  size="14px"
                  isBold
                  color={COLORS.Purple}
                  style={{ cursor: "pointer" }}
                >
                  <FormattedMessage
                    id="labelPrivacyPolicy"
                    defaultMessage="Privacy Policy"
                  />
                </Typography>
              </div>
              <div onClick={onOpenCookiePolicy}>
                <Typography
                  size="14px"
                  isBold
                  color={COLORS.Purple}
                  className="pl-4"
                  style={{ cursor: "pointer" }}
                >
                  <FormattedMessage
                    id="labelCookiePolicy"
                    defaultMessage="Cookie Policy"
                  />
                </Typography>
              </div>
            </div>
            <MyButton
              isPrimary
              bgColor={COLORS.GreenStrong}
              className="w-100"
              onClick={handleOpenConfirmSignOut}
            >
              <FormattedMessage id="btnSignout" defaultMessage="Sign Out" />
            </MyButton>
          </div>
        )}
      </div>
      <ModalConfirmSignOut />

      <PrivacyPolicyModal
        isOpen={isOpenPrivacyPolicy}
        onCancle={() => {
          setIsOpenPrivacyPolicy(false);
        }}
        onAcceptPolicy={handleClickAcceptPolicy}
      />

      <CookiePolicyModal
        isOpen={isOpenCookiePolicy}
        onCancle={() => {
          setIsOpenCookiePolicy(false);
        }}
      />

      <ChangePasswordModal
        isOpen={isOpenPasswordModal}
        onCancle={() => {
          setIsOpenPasswordModal(false);
        }}
      />
      <Modal
        className="custom-modal"
        open={isOpenConfirmModal}
        onCancel={() => {
          setIsOpenConfirmModal(false);
        }}
        width={300}
        onOk={handleClickCancelShipment}
        centered={true}
        style={{ height: "auto" }}
        footer={[
          <div>
            <MyButton
              onClick={() => {
                setIsOpenConfirmModal(false);
              }}
              style={{
                width: isDesktop ? "30%" : "30%",
                marginLeft: "0px",
                marginTop: "0px",
                marginRight: "5px",
              }}
            >
              <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
            </MyButton>{" "}
            <MyButton
              isPrimary
              onClick={handleClickCancelShipment}
              style={{
                width: isDesktop ? "30%" : "30%",
                marginInlineStart: "0px",
              }}
            >
              <FormattedMessage id="btnOK" defaultMessage="Ok" />
            </MyButton>
          </div>,
        ]}
      >
        <Typography
          isBold
          size="16px"
          color={COLORS.Primary}
          className="text-center p-2"
        >
          <FormattedMessage
            id="cancelShipment"
            defaultMessage="Cancel Shipment"
          />
        </Typography>
        <Typography className="text-center p-3 pb-4">
          <FormattedMessage
            id="cancelShipmentText"
            defaultMessage="Do you want to cancel shipment ?"
          />
        </Typography>
      </Modal>
    </Sider>
  );
};

const MainLayout = (props) => {
  const location = useLocation();
  const states = store.getState();
  const isDesktop = useIsDesktop();
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);
  const [isShowMobileMenu, setIsShowMobileMenu] = useState(false);
  const [selectedMenuKey, setSelectedMenuKey] = useState(["1"]);
  const [profileData, setProfileData] = useState();
  const [visibleProfile, setVisibleProfile] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const customerId = GetProfile("customerId");
  const comCode = GetProfile("customerCode");
  const username = states.authenReducer.username;
  const password = states.authenReducer.password;
  const refreshToken = states.authenReducer.refreshToken;
  const accessToken = states.authenReducer.accessToken;
  // //console.log('authenReducer', states.authenReducer);
  const [isOpenOrderModal, setIsOpenOrderModal] = useState(false);
  const [shipmentBodyCancel, setShipmentBodyCancel] = useState([]);
  const [isOpenShipmentModal, setIsOpenShipmentModal] = useState(false);
  const [focusShipmentDetail, setFocusShipmentDetail] = useState([]);
  const [isOpenPreviewModal, setIsOpenPreviewModal] = useState(false);
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
  const [isOpenInfoModal, setIsOpenInfoModal] = useState(false);
  const [isChangeLang, setIsChangeLang] = useState(false);

  // useEffect(() => {
  //   selectLang("EN");
  // }, [])

  // useEffect(() => {
  //   // Coded By Bazzzz EIEI :P
  //   const interval = setInterval(async () => {
  //     const nowTime = Math.floor(new Date().getTime() / 1000);
  //     const tokenExpire = states.authenReducer.tokenExpire;
  //     if (nowTime > tokenExpire - 20) {
  //       const _authenService = new authenService();
  //       const body = {
  //         client_id: `${AppConfig.CLIENT_ID}`,
  //         client_secret: `${AppConfig.CLIENT_SECRET}`,
  //         refresh_token: refreshToken,
  //       };
  //       await _authenService
  //         .logout(body)
  //         .then((response) => {
  //           persistor.purge();
  //           localStorage.clear()
  //           window.location.reload();
  //           // navigate('/login');
  //         })
  //         .catch((err) => {
  //           persistor.purge();
  //           window.location.reload();
  //         });
  //       clearInterval(interval); // เมื่อเงื่อนไขเป็นจริง หยุดการทำงานของ setInterval
  //     }
  //   }, 10000);
  // }, []);

  useEffect(() => {
    signinWithUsername();
  }, [isChangeLang]);

  const signinWithUsername = async () => {
    const _authenService = new authenService();
    const body = {
      client_id: `${AppConfig.CLIENT_ID}`,
      client_secret: `${AppConfig.CLIENT_SECRET}`,
      grant_type: `${AppConfig.GRANT_TYPE_LOGIN}`,
      username: `${AppConfig.PREFIX_USERNAME}` + username,
      password: password,
    };
    await _authenService
      .login(body)
      .then(async (response) => {
        const decoded = jwt_decode(response.access_token);
        const bodyLang = {
          companyId: process.env.REACT_APP_COMPANY_ID,
          lang: localStorage.getItem("lang") || "EN",
          pageCode: "frontloopmerchant.lng.v1",
        };
        try {
          const result = await instance.post(`/language/company`, bodyLang);

          if (_.get(result, "status") === 200) {
            dispatch(langActionn(_.get(result, "data[0]")));
            localStorage.setItem(
              "alllang",
              JSON.stringify(_.get(result, "data[0]"))
            );
            if (isChangeLang === true) {
              setTimeout(() => {
                window.location.reload();
                setIsChangeLang(false);
              }, 500);
            }
          }
        } catch (error) {}
        dispatch(
          login(
            response.access_token,
            response.expires_in,
            response.refresh_expires_in,
            response.refresh_token,
            response.token_type,
            response.session_state,
            response.scope,
            decoded.sub,
            decoded.exp,
            username,
            password
          )
        );
        // //console.log('tokennnnnn');
        getCustomerProfile(decoded.sub, decoded.exp);
      })
      .catch((err) => {});
  };

  const selectLang = async (value) => {
    localStorage.setItem("lang", value);
    setIsChangeLang(true);
    // window.location.reload();
  };

  const getCustomerProfile = async (cusRefId) => {
    const _customerService = new customerService();
    await _customerService
      .getCustomerProfile(cusRefId)
      .then(async (response) => {
        dispatch(customer_profile(response.data));
        const mapkey = await getGeoCompanyApi();
        dispatch(mapKeyAction(_.get(mapkey, "data.GEO_APIKEY")));
      })
      .catch((err) => {});
  };

  const handleChangeMenu = (newKey) => {
    const newSelectedKey = [newKey];
    setSelectedMenuKey(newSelectedKey);
  };

  useEffect(() => {
    if (_.get(selectedMenuKey, "[0]") === "2") {
      setIsShowMobileMenu(false);
    }
  }, [selectedMenuKey]);

  useEffect(() => {
    const path = location.pathname;

    
    if (path === "/checkingstatus") {
      setSelectedMenuKey(["2"]);
    }
    if (path === "/queue") {
      setSelectedMenuKey(["3"]);
    }
    if (path === "/customer") {
      setSelectedMenuKey(["4"]);
    }

  }, [location]);

  const handleClickViewProfile = () => {
    setVisibleProfile(true);
  };

  const handleCancleViewProfile = () => {
    setVisibleProfile(false);
  };

  useEffect(() => {
    const getProfile = async () => {
      try {
        const response = await instance.get(
          `/v3/business-partner/manager/company/${comCode}/customer-informations/${customerId}`
        );
        setProfileData(response?.data?.data);
      } catch (error) {}
    };
    if (customerId && comCode) {
      getProfile();
    }
  }, [customerId, comCode, trigger]);

  const handleClickCreateOrder = () => {
    setIsOpenOrderModal(true);
  };

  const handleCloseOrderModal = () => {
    setIsOpenOrderModal(false);
  };

  const handleClickSaveShipmentOrder = (info) => {
    setFocusShipmentDetail(info);
    setIsOpenShipmentModal(true);
    setIsOpenOrderModal(false);
    // setShipmentBodyCancel((e) => ({
    //   ...e,
    //   statusDetail: {
    //     sequence: 2,
    //     statusCode: "canceled",
    //     statusColor: "#898989",
    //     statusId: "63e215bad1d35a62710f5b0f",
    //     statusName: "Canceled",
    //     statusText: { EN: "Canceled", TH: "ยกเลิก" },
    //   },
    // }));
  };

  const handleCloseShipmentDetail = () => {
    setIsOpenShipmentModal(false);
  };

  const handleClickPrint = () => {
    setIsOpenPreviewModal(true);
  };

  const handleClosePreviewModal = () => {
    setIsOpenPreviewModal(false);
  };

  const handleCloseInfoModal = () => {
    setIsOpenInfoModal(false);
  };

  if (accessToken) {
    return (
      <>
        <Layout
          style={{
            minHeight: "100vh",
            height: "100vh",
            background: "white",
            overflow: "hidden",
          }}
        >
          {!isShowMobileMenu ? (
            <>
              <Layout>
                {isDesktop ? (
                  <MySider
                    collapsed={collapsed}
                    onCollapse={(value) => setCollapsed(value)}
                    onClickMenuIcon={() => setCollapsed(!collapsed)}
                    onViewProfile={handleClickViewProfile}
                    selectedMenuKey={selectedMenuKey}
                    onChangeMenu={handleChangeMenu}
                    profileData={profileData}
                    selectLang={selectLang}
                    handleClickCreateOrder={handleClickCreateOrder}
                    focusShipmentDetail={focusShipmentDetail}
                    shipmentBodyCancel={shipmentBodyCancel}
                    setIsOpenConfirmModal={setIsOpenConfirmModal}
                    setIsOpenShipmentModal={setIsOpenShipmentModal}
                    isOpenConfirmModal={isOpenConfirmModal}
                  />
                ) : (
                  <></>
                )}
                <Layout className="site-layout">
                  <MyHeader
                    onToggleMenu={() => {
                      setIsShowMobileMenu(true);
                    }}
                  />
                  <Content
                    style={{
                      height: isDesktop
                        ? "calc(100vh - 115px)"
                        : "calc(100vh - 70px)",
                      maxHeight: isDesktop
                        ? "calc(100vh - 112px)"
                        : "calc(100vh - 65px)",
                      background: COLORS.Bg,
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      overflow: "auto",
                    }}
                  >
                    <Outlet />
                  </Content>
                </Layout>
              </Layout>
              {isDesktop && <MyFooter />}
            </>
          ) : (
            <MySider
              onClickMenuIcon={() => setIsShowMobileMenu(false)}
              onViewProfile={handleClickViewProfile}
              selectedMenuKey={selectedMenuKey}
              onChangeMenu={handleChangeMenu}
              profileData={profileData}
              selectLang={selectLang}
              handleClickCreateOrder={handleClickCreateOrder}
              focusShipmentDetail={focusShipmentDetail}
              shipmentBodyCancel={shipmentBodyCancel}
              setIsOpenConfirmModal={setIsOpenConfirmModal}
              setIsOpenShipmentModal={setIsOpenShipmentModal}
              isOpenConfirmModal={isOpenConfirmModal}
            />
          )}
          <UserProfileModal
            isOpen={visibleProfile}
            onCancle={handleCancleViewProfile}
            setTrigger={setTrigger}
          />

          <OrderModal
            isOpen={isOpenOrderModal}
            onCancle={handleCloseOrderModal}
            onSave={handleClickSaveShipmentOrder}
            setShipmentBodyCancel={setShipmentBodyCancel}
            setFocusShipmentDetail={setFocusShipmentDetail}
          />
          <ShipmentDetailModal
            info={focusShipmentDetail}
            isOpen={isOpenShipmentModal}
            onCancle={handleCloseShipmentDetail}
            onClickPrint={handleClickPrint}
            setFocusShipmentDetail={setFocusShipmentDetail}
            onCancleShipment={() => {
              setIsOpenConfirmModal(true);
            }}
            isPreview
          />
          <ShipmentPreviewModal
            info={focusShipmentDetail}
            isOpen={isOpenPreviewModal}
            onCancle={handleClosePreviewModal}
            parcels={focusShipmentDetail?.parcels || []}
            totalParcel={focusShipmentDetail?.totalParcel || 0}
          />
        </Layout>
      </>
    );
  } else {
    return <Navigate replace to={ROUTES.Login} />;
  }
};

export default MainLayout;
